module.exports = __webpack_public_path__ + "static/img/tradinghours.400566b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/tradinghours.svg
// module id = sbYu
// module chunks = 4